import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ChatIcon from "@mui/icons-material/Chat";
import ThreePIcon from "@mui/icons-material/ThreeP";
import PeopleIcon from "@mui/icons-material/People";
import SettingsIcon from "@mui/icons-material/Settings";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AnalyticsSharpIcon from "@mui/icons-material/AnalyticsSharp";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import AddTaskIcon from "@mui/icons-material/AddTask";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import WarehouseIcon from "@mui/icons-material/Warehouse";
// import WorkHistoryIcon from "@mui/icons-material/WorkHistory";

export const adminDashboardMenu = [
  {
    name: "Chats",
    path: "/chats",
    icon: <ChatIcon />,
  },
  {
    name: "My Work Report",
    path: "/task",
    icon: <AddTaskIcon />,
  },
  {
    name: "Organization",
    path: "/employee",
    icon: <CorporateFareIcon />,
  },
  {
    name: "Pending Request",
    path: "/pending-request",
    icon: <PendingActionsIcon />,
  },

  {
    name: "Employee Chat",
    path: "/user-chat",
    icon: <ThreePIcon />,
  },
  {
    name: "Settings",
    path: "/settings",
    icon: <SettingsIcon />,
  },
];

export const employeeDashboardMenu = [
  {
    name: "Chats",
    path: "/chats",
    icon: <ChatIcon />,
  },
  {
    name: "My Work Report",
    path: "/task",
    icon: <AddTaskIcon />,
  },
  {
    name: "Settings",
    path: "/settings",
    icon: <SettingsIcon />,
  },
];

export const wareHouseDashboardMenu = [
  {
    name: "Chats",
    path: "/chats",
    icon: <ChatIcon />,
  },
  // {
  //   name: "Organization",
  //   path: "/employee",
  //   icon: <CorporateFareIcon />,
  // },
  {
    name: "Department Report",
    path: "/task",
    icon: <AssignmentIndIcon />,
  },
  {
    name: "My Work Report",
    path: "/task-admin",
    icon: <AddTaskIcon />,
  },
  {
    name: "Settings",
    path: "/settings",
    icon: <SettingsIcon />,
  },
];
